import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Wait for auth check before mounting so UI reflects stored token state
store.dispatch('auth/checkAuth').then(() => {
	const app = createApp(App)
	app.use(store).use(router)
	app.config.compilerOptions = app.config.compilerOptions || {}
	app.config.compilerOptions.isCustomElement = tag => false
	app.mount('#app')
})